'use strict';
(function () {
  angular.module('pentaApp').factory('clubCardTemplateForClient.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/clubCardTemplateForClient', {}, {
      query: {
        method: 'GET',
        isArray: true,
      },
      createCards: {
        method: 'POST',
        isArray: true
      }
    });
  }

})();